var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostfachSprechblasen03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    "data-name": "Ebene 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 291 266.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-5 {\n        fill: #ff6b00;\n      }\n\n      .cls-5, .cls-2 {\n        opacity: .8;\n      }\n\n      .cls-6 {\n        fill: #666;\n        opacity: .3;\n      }\n\n      .cls-3 {\n        opacity: .6;\n      }\n\n      .cls-4 {\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 6px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_7",
    "data-name": "Ebene 7"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m183.33,0H27.67C12.39,0,0,12.39,0,27.67v105.67c0,14.99,11.93,27.19,26.81,27.65.21,11.92-4.95,23.27-14.81,31.94,27.07-1.19,49.67-14.21,57.88-31.92h113.45c15.28,0,27.67-12.39,27.67-27.67V27.67c0-15.28-12.39-27.67-27.67-27.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29,
    y1: 40,
    x2: 108.89,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29,
    y1: 62,
    x2: 183,
    y2: 62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29,
    y1: 84,
    x2: 183,
    y2: 84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29,
    y1: 106,
    x2: 183,
    y2: 106
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 29,
    y1: 128,
    x2: 168.56,
    y2: 128
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m151.11,119h118.78c11.66,0,21.11,9.45,21.11,21.11v80.63c0,11.44-9.1,20.75-20.46,21.09-.16,9.09,3.77,17.76,11.3,24.37-20.66-.91-37.9-10.84-44.17-24.36h-86.57c-11.66,0-21.11-9.45-21.11-21.11v-80.63c0-11.66,9.45-21.11,21.11-21.11Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 241.39,
    cy: 183.12,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 180.61,
    cy: 183.12,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 211,
    cy: 183.12,
    r: 7.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostfachSprechblasen03);
export default __webpack_public_path__ + "static/media/Postfach Sprechblasen 03.d6c46770407439176b9ea382d6a3f9b9.svg";
export { ForwardRef as ReactComponent };